import React from 'react';

export const ArrowUpIcon: React.FC<React.SVGAttributes<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="6.031"
    viewBox="0 0 10 6.031"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M7647.49,711.217l-4.32,4.552a0.781,0.781,0,0,0,0,1.049,0.685,0.685,0,0,0,1,0l3.81-4.028,3.82,4.028a0.674,0.674,0,0,0,.99,0,0.76,0.76,0,0,0,0-1.049l-4.31-4.552a0.692,0.692,0,0,0-.5-0.217A0.655,0.655,0,0,0,7647.49,711.217Z"
      transform="translate(-7643 -711)"
    />
  </svg>
);
